// Code description lookups may or may not include cost centers.
// If cost centers are not included, results may come back in the
// form
// {
//   "31000099-2007257": {
//      "codeType": "TECH",
//      "code": "31000099",...
//    },
//    "31000099-2007254": {
//       "codeType": "TECH",
//       "code": "31000099",
//     },
// }
// For the purposes of the displaying the *description* to the UI
// we assume that the *description* and the *shortDescription* will be
// standard across cost centers.
// The resulting output will be a single code:
// {
//   "310000997": {
//      "codeType": "TECH",
//      "code": "31000099",...
//    }
// }
export const normalizeDescriptions = (
  descriptions: CMxAPI.CodeResponse
): CMxAPI.CodeResponse => {
  const codeMap = {};
  Object.values(descriptions).forEach(entry => {
    codeMap[entry.code] = entry;
  });
  return codeMap;
};
